<template>
    <div class="ChurchEngagementLayout" v-if="UserPrivateProfile.UserId">
            <nav class="navbar navbar-light navbar-expand-md navigation-clean">
                <div class="container-fluid">
                    <a id="navbar-brand" class="navbar-brand pointer"><img v-bind:src="sitelogo" /></a>          
                    <div style="float:right;">
                        <b-navbar-toggle target="nav-collapse" style="margin-top:1rem;" right></b-navbar-toggle>
                        <b-collapse id="nav-collapse" is-nav right>
                            <b-navbar-nav pills right variant="light">
                                <b-nav-item class="hidden" role="presentation"></b-nav-item>
                                <b-nav-item v-on:click="ChangePaneShown('ChurchPaneShown')" v-bind:class="{ active: PanesShown.ChurchPaneShown }"><font-awesome-icon :icon="['fa', 'church']"/> Churches</b-nav-item>
                                <b-nav-item v-on:click="ChangePaneShown('DocumentsPaneShown')" v-bind:class="{ active: PanesShown.DocumentsPaneShown }"><font-awesome-icon :icon="['fa', 'file-alt']"/> Documents</b-nav-item>
                                <b-nav-item><Logout /></b-nav-item>
                            </b-navbar-nav>
                        </b-collapse>
                    </div>
                </div>
            </nav>

        <div class="tab-content col-12 padding-adjust-for-overlay-scroll">
            <div class="tab-pane fade active show" role="tabpanel" id="tab-home">
                <div id="ChurchesHomeTab">

                </div>
            </div>
            <div v-show="PanesShown.ChurchPaneShown">
                <ChurchPane />
            </div>
            <div v-show="PanesShown.DocumentsPaneShown">
                <DocumentsPane />
            </div>
        </div>
        <!--Logged in User-->
        <p class="upper-right" v-if="UserPrivateProfile.FirstName">Logged in as: {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</p>
    </div>
</template>

<script>
    //import services
    import { UserAPI } from '../../../services/api/Core/UserAPI.js';
    //import components
    import ChurchPane from '../Churches/ChurchPane.vue';
    import DocumentsPane from '../../Core/RecordComponents/DocumentsPane.vue';
    import Logout from '../../Core/UI/Logout.vue';


    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faChurch } from '@fortawesome/free-solid-svg-icons';
    library.add(faChurch);
    import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faFileAlt);

    
    export default {
        name: "ChurchEngagementLayout",
        created() {
            const userAPI = new UserAPI(this.$baseURL);
            this.userAPI = userAPI;
            this.$store.commit("User.PrivateProfile.Clear");
        },
        data: function () {
            return {
                sitelogo: "/images/OliveCrestLogo_Banner_ChurchEngagementPortal.png",
                PanesShown: {
                    ChurchPaneShown: true,
                    DocumentsPaneShown: false,
                },
                EmployeePrivateProfile: {
                    UserID: "",
                    EmployeeID: "",
                    Email: "",
                    FirstName: "",
                    LastName: "",
                    AssignedSubPrograms: [],
                    Permissions: [],
                    Roles: []
                },
                CoreProgramData: {
                    CoreProgramID: "",
                    CoreProgramName: "",
                    WarningAnnouncements: [],
                    Agencies: [],
                }
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                //loop through Panes shown and flip true/false values
                Object.keys(this.PanesShown).forEach(key => {
                    if (key == paneName) {
                        this.PanesShown[key] = true;
                    } else {
                        this.PanesShown[key] = false;
                    }
                });
            },
            GetEmployeePrivateProfile() {
                this.userAPI.GetEmployeePrivateProfile().then((data) => {
                    data.data.AssignedSubPrograms = data.data.AssignedSubPrograms.filter(sp => sp.CoreProgram.Name == "ChurchEngagement");
                    //this.EmployeePrivateProfile = data.data;
                    this.$store.commit("User.PrivateProfile.Replace", data.data);
                });
            }
        },
        components: {
            ChurchPane,
            DocumentsPane,
            Logout
        },
        mounted() {
            this.GetEmployeePrivateProfile();
        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            }
        }
    }
</script>

<style scoped>
    .upper-right {
        position:absolute;
        top:0;
        right:40px;
    }
    .ChurchEngagementLayout {
        background-color: #605271;
    }
</style>